<template>
    <div :class="['row', 'py-2', 'no-gutters', 'lesson-wrapper', {
        'inprogress' : lesson.extendedProps.isInProgress,
        'rejected' : lesson.extendedProps.rejected,
        'ended' : lesson.extendedProps.isEnded && !lesson.extendedProps.rejected
    }]">
        <div :class="['col-12 col-lg-4 lesson-time-wrapper', {'non-msk-tz' : !isMskTimezone}]">
            <div class="lesson-marker d-inline-block ml-2 align-middle" :style="{ 'backgroundColor': color(lesson) }">
            </div>
            <div class="lesson-time d-inline-block align-middle px-3">
                {{ startTime }}
                <span class="mks-start-time" v-if="!isMskTimezone"
                      :title="$t('moscow_time_notice')">{{ startTimeMsk }}</span>
            </div>
            <div class="lesson-title d-inline-block align-middle pr-2">
                <div class="lesson-title-1">{{ lesson.className }}</div>
                <div class="lesson-title-2" v-if="lesson.extendedProps.isInProgress && !lesson.extendedProps.rejected">
                    {{ $t('now_in_progress') }}
                </div>
                <div :class="['lesson-title-2', {'lesson-created' : lesson.lesson}]"
                     v-if="lesson.extendedProps.isUpcoming && !lesson.extendedProps.rejected">{{ $t('start_through') }}: {{
                    timeToStart }}
                </div>
            </div>
        </div>
        <!-- отмененно -->
        <div class="col-12 col-lg-8 lesson-status-wrapper" v-if="lesson.extendedProps.rejected">
            <div class="lesson-status d-inline-block align-middle">{{ $t('lesson_canceled') }}:(</div>
        </div>
        <!-- закончилось -->
        <div class="col-12 col-lg-8 lesson-status-wrapper" v-else-if="lesson.extendedProps.isEnded">
            <div class="lesson-status d-inline-block align-middle">{{ $t('lesson_ended') }}</div>
            <div class="ml-5 lesson-rate d-inline-block align-middle"
                 v-if="lesson.lesson && !lesson.lesson.restricted && !lessonRate">
                <router-link :to="`/user/profile/timetables/rate/${lesson.lesson.id}`">
                    <i class="fa fa-star fa-star-o"></i>
                    <i class="fa fa-star fa-star-o"></i>
                    <i class="fa fa-star fa-star-o"></i>
                    <i class="fa fa-star fa-star-o"></i>
                    <i class="fa fa-star fa-star-o"></i><br>
                    <span>{{ $t('rate_lesson') }}</span>
                </router-link>
            </div>
            <div class="ml-5 lesson-rate d-inline-block align-middle"
                 v-if="lesson.lesson && !lesson.lesson.restricted && lessonRate">
                <i v-for="index in 5" :key="index" :title="$t('your_lesson_rate')" :class="['fa', {'fa-star' : index <= lessonRate.rate}, {'fa-star fa-star-o' : index > lessonRate.rate}] "></i>
            </div>
        </div>
        <!-- скоро будет, ссылки нет -->
        <div class="col-12 col-lg-8 lesson-status-wrapper"
             v-else-if="lesson.extendedProps.isUpcoming && lesson.extendedProps.secondsToStart > 3600  ">
            <div class="lesson-status d-inline-block align-middle">
                {{ $t('lesson_link_info') }}
            </div>
        </div>
        <div class="col-12 col-lg-8 lesson-status-wrapper" v-else-if="lesson.lesson && lesson.lesson.restricted">
            <div class="lesson-status d-inline-block align-middle">
                {{ $t('lesson_subscription_required') }}
            </div>
        </div>
        <!-- началось или будет скоро, ссылка есть -->
        <div class="col-12 col-lg-8 lesson-link-wrapper"
             v-else-if="((lesson.extendedProps.isUpcoming && lesson.extendedProps.secondsToStart <= 3600) || lesson.extendedProps.isInProgress)">
            <div class="row">
                <div class="col-12 col-lg-7 lesson-link">
                    <router-link to="/go">{{ $t('go_to_zoom') }}</router-link>
                    <!-- <span v-clipboard="lesson.lesson.zoom_url"
                          title="Скопировать ссылку на конференцию">Копировать ссылку</span> -->
                </div>
                <!--
                <div class="col-12 col-lg-5 lesson-pass my-4 my-lg-0">
                    Пароль:
                    <input class="mx-3" :type="showPass ? 'text' : 'password'"
                           :value="lesson.lesson.zoom_password" disabled/><span
                        :class="['show-pass', { 'show' : showPass}]" title="Показать/скрыть пароль"
                        @click="showPass = !showPass"></span>
                    <img src="@/assets/poliglotiki/images/copy-pass-icon.png" v-clipboard="lesson.lesson.zoom_password"
                         title="Скопировать пароль"/>
                </div>
                -->
            </div>
        </div>


    </div>
</template>

<style scoped>

    .fa.fa-star.fa-star-o {
        color: #8e8c7c6b;
    }

    .mks-start-time {
        display: block;
        opacity: 0.9;
        font-size: 11px;
        margin-top: 4px;
        cursor: help;
    }

    .lesson-wrapper {
        min-height: 90px;
        border: 1px solid #d7e1e5;
        margin-top: -1px;
    }

    .lesson-wrapper.ended {
        background-color: #f7fafb;
    }

    .lesson-wrapper.rejected {
        background-color: #feeff0;
    }

    .lesson-wrapper.inprogress {
        box-shadow: 0px 0px 7px 3px #0000001c;
        z-index: 2;
        overflow: visible;
        position: inherit;
    }

    .lesson-marker {
        width: 20px;
        height: 70px;
    }

    .lesson-time, .lesson-title-1 {
        font-family: "Manrope Bold";
        color: #8b8496;
        font-size: 18px;
    }

    .ended .lesson-time {
        color: #8b8496;
    }

    .inprogress .lesson-time, .inprogress .lesson-title-1 {
        color: #231c37;
    }

    .rejected .lesson-time {
        color: #8b8496;
    }

    .lesson-title-2 {
        font-family: "Manrope Bold";
        font-size: 14px;
        color: #4f4d5c;
    }

    .inprogress .lesson-title-2 {
        color: #5ab947;
    }

    .lesson-status {
        font-family: "Manrope Bold";
        font-size: 16px;
        color: #8b8496;
        height: 70%;
        padding-left: 15px;
        line-height: 50px;
    }

    .rejected .lesson-status {
        color: #4f4d5c;
    }

    .lesson-title {
        overflow: hidden;
        max-width: 66%;
    }

    .lesson-wrapper, .lesson-pass {
        display: flex;
        align-items: center;
    }

    .lesson-link {
        height: 70%;
        padding-left: 15px;
        line-height: 50px;
    }

    .lesson-link a {
        font-family: "Manrope Light";
        position: relative;
        font-size: 16px;
        color: #0489c7;
        text-decoration: underline;
    }

    .lesson-link a::after {
        background-image: url('~@/assets/poliglotiki/images/zoom-icon.png');
        display: block;
        content: ' ';
        height: 24px;
        width: 24px;
        position: absolute;
        right: -32px;
        top: -1px;
    }

    .lesson-link span {
        font-family: "Manrope Light";
        position: relative;
        font-size: 14px;
        color: #5ab947;
        text-decoration: underline;
        margin-left: 70px;
        cursor: pointer;
    }

    .lesson-link span::after {
        background-image: url('~@/assets/poliglotiki/images/copy-link-icon.png');
        display: block;
        content: ' ';
        height: 13px;
        width: 13px;
        position: absolute;
        right: -19px;
        top: 3px;
    }

    .lesson-pass > img {
        cursor: pointer;
    }

    .lesson-pass {
        color: #8b8496;
        font-size: 14px;
        font-family: "Manrope Light";
    }

    .lesson-pass input {
        border: 1px solid #cdcbcf;
        border-radius: 5px;
        background-color: white;
        color: #231c37;
        font-size: 14px;
        width: 130px;
        padding: 3px 10px;
        font-family: "Manrope Bold";
    }

    .lesson-pass input[type=text] {
        cursor: text;
    }

    .show-pass {
        position: relative;
        cursor: pointer;
    }

    .show-pass::after {
        background-image: url('~@/assets/poliglotiki/images/show-pass-icon.png');
        background-repeat: no-repeat;
        background-position: center;
        display: block;
        content: ' ';
        height: 10px;
        width: 18px;
        position: absolute;
        right: 23px;
        top: -5px;
    }

    .show.show-pass::after {
        background-image: url('~@/assets/poliglotiki/images/hide-pass-icon.png');
    }

    .lesson-title-2.lesson-created {
        color: #f15b22;
    }

    .lesson-link-wrapper {
        padding-left: 15px;
    }

    .lesson-rate {
        opacity: 0.5;
        text-align: center;
    }

    .lesson-rate:hover {
        opacity: 1;
    }

    .lesson-rate i {
        color: #ffdb00;
    }

    .lesson-rate a:hover span {
        text-decoration: underline;
    }

    .lesson-rate a span {
        font-size: 13px;
        color: #8b8496;
    }

    @media (min-width: 1199.99px) {
        .lesson-link {
            border-left: 1px solid #d7e1e5;
        }

        .lesson-status {
            border-left: 1px solid #d7e1e5;
        }
    }

    @media (max-width: 1199.98px) {
        .lesson-wrapper {
            box-shadow: 3px 7px 8px -2px #0000001c;
        }

        .lesson-status-wrapper,
        .lesson-link {
            margin-top: 20px;
        }

        .lesson-link-wrapper {
            padding-left: 15px;
            padding-right: 15px;
        }

        .lesson-link {
            padding-top: 10px;
        }

        .lesson-pass {
            padding-top: 25px;
        }

        .lesson-link, .lesson-pass {
            padding-left: 15px;
            padding-right: 15px;
        }

        .lesson-status {
            line-height: 20px;
            margin: 20px 0;
        }

        .lesson-status-wrapper::before,
        .lesson-link::before,
        .lesson-pass::before {
            width: 95%;
            height: 1px;
            background-color: #d7e1e5;
            display: block;
            content: ' ';
            position: absolute;
            top: -6px;
            left: 0;
            right: 0;
            margin: 0 auto;
        }

        .lesson-wrapper.inprogress {
            border-top: 6px solid #5bb947;
            border-bottom: 6px solid #5bb947;
        }

        .lesson-link a {
            margin-right: 50px;
        }

        .lesson-link span {
            white-space: nowrap;
            margin-left: 2px;
        }
    }

</style>


<script>

    import userApi from "../../../data/UserApi";
    import moment from 'moment';
    import OnlineLessonRateApi from "../../../data/OnlineLessonRateApi";
    import StarRating from 'vue-star-rating'

    export default {
        name: "Lesson",
        props: {
            lesson: Object,
        },


        mounted() {
            this.isMskTimezone = userApi.isMskTimezone()

            if (this.lesson.lesson && !this.lesson.lesson.restricted) {
                OnlineLessonRateApi.fetchRateByLessonId(this.lesson.lesson.id)
                    .then(async response => {
                        this.lessonRate = response;
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        },

        computed: {
            timeToStart() {
                var mins = Math.trunc(this.lesson.extendedProps.secondsToStart / 60)
                var hours = 0
                if (mins > 60) {
                    hours = Math.trunc(mins / 60)
                    mins = mins % 60
                }
                if (hours > 0) return hours + "ч " + mins + "м"
                return mins + " мин"
            },

            startTime() {
                const str = this.lesson.dateStart
                //ProgressMe похоже возвращает время в UTC для запроса расписания по ученикам
                return moment(str + ".000+0000").format("HH:mm");
            },

            startTimeMsk() {
                const str = this.lesson.dateStart
                if (this.isMskTimezone) return null
                return moment(str + ".000+0000").utcOffset('+0300').format("HH:mm") + "\u00A0МСК";
            },

        },

        data() {
            return {
                showPass: false,
                isMskTimezone: true,
                lessonRate: null,
            }
        },

        methods: {
            color(item) {
              if (item.color) return item.color
              return "hsla(" + item.lessonId * 10 + ", 50%, 50%, 0.3)"
            },
            copyLink() {

            },
            copyPass() {

            },
        }
    }
</script>

